import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { cn } from '@/utils/styles';

interface MicrobiomeProfileCardProps {
  title: string;
  mediaUrl: any;
  onClick?: () => void;
  'data-testid'?: string;
}

export const MicrobiomeProfileCard: React.FC<MicrobiomeProfileCardProps> = ({
  title,
  mediaUrl,
  onClick,
  'data-testid': testId,
}) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'w-full p-4 rounded-lg shadow-md bg-black flex items-center gap-4 transition-transform transform border border-stroke-primary-subtle',
      )}
      aria-label={`Microbiome Profile Card: ${title}`}
      data-testid={testId}
    >
      {/* Media Section */}
      <div className="w-12 h-12 ">
        {mediaUrl && <Player autoplay loop src={mediaUrl} />}
      </div>

      {/* Content Section */}
      <div className="flex flex-col text-start">
        {title.split(' ').map((line, index) => (
          <p
            key={`${line}-line-${index}`}
            className="typography-caption1 text-primary font-medium"
          >
            {line}
          </p>
        ))}
      </div>
    </button>
  );
};
